import { ONBOARDING_STATUS, resolveOnboardingStatus } from '@/utils/auth/agreements';

/**
 * The signed-in user's BE record: educators live in the main store, volunteers and org admins in the employee store.
 * @param {{ appStore: Object, mainStore: Object, employeeStore: Object }} stores
 * @returns {Object|undefined}
 */
export const getCurrentUserData = ({ appStore, mainStore, employeeStore }) => (appStore.isEducator ? mainStore.user.data : employeeStore.user.data);

/**
 * Whether the signed-in user is new to the app or being sent back to onboarding.
 * @param {{ appStore: Object, mainStore: Object, employeeStore: Object }} stores
 * @returns {'new'|'returning'}
 */
export const getOnboardingStatus = (stores) =>
    stores.appStore.returningToOnboarding ? ONBOARDING_STATUS.RETURNING : resolveOnboardingStatus(getCurrentUserData(stores));
